//import store from "../../store";
const impressumRoutes = [
  {
    path: "/AGB_De",
    component: () =>
      import(
        /*webpackChunkName: 'component-homepage' */ "@/pages/AGB_De.vue"
      ), 
      
  },
];

export default impressumRoutes;
